import * as React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import { useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../../../Config';
import { Label } from 'semantic-ui-react';

export default function NativeSelectDemo() {
    const [category,setcategorydata] = useState([]);
    const [value,setValue] = useState('');

    const categorydata = async () => {
        await axios
        .post(`${API_URL}/indexData.php?type=category`, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then(async (req) => {
          if (req.data) {
            setcategorydata(req.data);
            }
        })
        .catch((res) => {
          
        });
    };

    useEffect(() => {
        categorydata();
    }, []);
  return (   
        <Box className='select_one'>
                <Container maxWidth='xl' className='man-sec'>
                    <Grid container spacing={2}>
                        <Grid item lg={12} sm={12} xs={12}>
                            <FormControl fullWidth className='fdsf'>
                                <Label className='lab_dec'>Category</Label>
                                <Typography variant='h6' fontSize='15px' lineHeight='22px' letterSpacing='0.3px' paddingBottom='5px' color='#686464'> Adding a category will help make your item discoverable on mintdaq</Typography>
                                <InputLabel id="demo-simple-select-autowidth-label"></InputLabel>
                                <Select labelId="demo-simple-select-autowidth-label" id="demo-simple-select-autowidth"
                                     autoWidth label="category" 
                                     value={value} 
                                     onChange={e=>setValue(e.target.value)}
                                     name='category' >
             
                                   {category.length>0 && category.map((data)=>(
                                    <MenuItem value={data.category_name} key={data.id} >{data.category_name}</MenuItem>

                                   ))}
                                    
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
  );
}